import type { PayGateApi } from '@env0/common-pay-gate/api';
import { useGetBillingInformation } from 'stores/rq/billing';

export const usePayGateFeature = (
  featureName: PayGateApi.FeatureName,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { isLoading: isQueryLoading, isFetched, data } = useGetBillingInformation({ enabled });
  // The query is shared, and TemplateWizardContainer and DriftDetectionWrapper swap their children for a loader
  // while a gate loads. So a disabled gate never loads (another reader's fetch dropped the onboarding wizard's
  // input), and an enabled one loads only until the first read settles (a child retrying a failed read looped).
  const isLoading = enabled && isQueryLoading && !isFetched;

  const activated = Boolean((data?.[featureName] as PayGateApi.BooleanPayGateValue)?.activated);

  return {
    payGateTitleId: activated || isLoading ? '' : 'paygate.feature.disabled',
    activated,
    isLoading
  };
};
